import visitorAxiosInstance from "../instance/visitorAxiosInstance";

class VisitorApi {
  static async getSingleProfile(username) {
    try {
      const response = await visitorAxiosInstance.get(`/profile/${username}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getDistricts(cityId) {
    if (cityId === undefined || cityId === null || cityId === "") {
      return { data: [] };
    }
    try {
      const response = await visitorAxiosInstance.get(
        `/${cityId}/district-list`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getCitiesList() {
    try {
      const response = await visitorAxiosInstance.get("/cities-list");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getPropertyTypes(type) {
    try {
      const response = await visitorAxiosInstance.get("/property-types", {
        params: type !== undefined && type !== null ? { type } : {},
      });
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async searchProfile(params = {}) {
    try {
      const response = await visitorAxiosInstance.get("/search-profile", {
        params,
      });
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async contactUs(formData) {
    try {
      const response = await visitorAxiosInstance.post(
        `/contact-us-query`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async createInquiry(formData) {
    try {
      const response = await visitorAxiosInstance.post(
        "/inquiry-create",
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async createGeneralInquiry(payload) {
    try {
      const response = await visitorAxiosInstance.post(
        "/general-inquiry-create",
        payload
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default VisitorApi;
